

exports.__esModule = true;
exports.$xoTokenizedWalletLoader = undefined;

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _angular = require('angular');

var _auth = require('xo-models/src/auth');

var _app = require('xo-models/src/app');

var _factory = require('./factory');

require('xo-ui-components/src/card-loader/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ANIMATION_STATUSES = {
    NOT_STARTED: 'notStarted',
    PENDING: 'pending',
    COMPLETED: 'completed'
};

// card loader component - used only in tokenized wallet flows.
var $xoTokenizedWalletLoader = exports.$xoTokenizedWalletLoader = _squid.$Component.extend('$xoTokenizedWalletLoader', {
    tag: 'xo-tokenized-wallet-loader',
    template: _template2['default'],
    props: {
        planDone: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                tokenizedWalletInfoModel: _app.$TokenizedWalletInfoModel.instance(_angular.$rootScope.token).retrieve()['catch'](_angular.noop)
            };
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.auth = _auth.$AuthModel.instance();
            // start animation of the card
            this.setbuyerProgress = ANIMATION_STATUSES.NOT_STARTED;
            _logger.$logger.info('tokenized_wallet', {
                from: 'adding_pp_ap_animation',
                to: 'prepare_adding_pp_ap_animation',
                context_id: _angular.$rootScope.token,
                context_type: 'EC-Token',
                billing_token: _squid.$meta.baToken
            });

            // sets animation state to 80%
            (0, _angular.$timeout)(function () {
                _this.setbuyerProgress = ANIMATION_STATUSES.PENDING;
                _logger.$logger.info('tokenized_wallet', {
                    from: 'adding_pp_ap_animation',
                    to: 'process_adding_pp_ap_animation',
                    context_id: _angular.$rootScope.token,
                    context_type: 'EC-Token',
                    billing_token: _squid.$meta.baToken
                });
            }, 300);

            // watch when planning is completed in xo-login/directive
            // to redirect to "checkout.tokenizationInfo" page
            this.$watch('planDone', function (planDone) {
                if (planDone) {
                    _factory.$TokenizedWalledLoaderFactory.goToTokenizationInfoPage();
                }
            });
        },
        populate: function populate() {
            this.cardLoaderMessage = _factory.$TokenizedWalledLoaderFactory.getCardLoaderMessage(this.models.tokenizedWalletInfoModel);
            this.logoClass = this.models.tokenizedWalletInfoModel.getSubject();
        }
    }
});

angular.value("$xoTokenizedWalletLoader", $xoTokenizedWalletLoader);
_squid.$Component;

_squid.$meta;

_logger.$logger;

_angular.$timeout;

_angular.$rootScope;

_angular.noop;

_auth.$AuthModel;

_app.$TokenizedWalletInfoModel;

_factory.$TokenizedWalledLoaderFactory;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-login/tokenized-wallet-loader/directive.js
// module id = ./pages/xo-login/tokenized-wallet-loader/directive.js
// module chunks = 0